const modules = import.meta.glob('./*/*.ts');

export async function loadLanguageTranslations(lang: string): Promise<Record<string, unknown>> {
  const path = `./${lang}/common.ts`;
  if (modules[path]) {
    const mod = await modules[path]() as { default: Record<string, unknown> };
    return mod.default ?? {};
  }
  return {};
}
